<template>
    <div class="MentoringHowToSteps w-full bg-white dark:bg-surface-card py-10">
        <div
            class="container flex w-full flex-col justify-center pt-14"
            :class="{ 'my-10 lg:my-10': variant === 'margin-sm' }"
        >
            <h2 class="mb-4 text-center text-4xl font-black text-black dark:text-white lg:leading-[46.8px]">{{ title }}</h2>
            <div class="_items-wrap">
                <slot name="item1" />
                <slot name="item2" />
                <slot name="item3" />
                <slot name="item4" />
                <slot v-if="$slots.item5" name="item5" />
            </div>
            <div class="mt-24 flex justify-center">
                <slot name="footer" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps({
    title: {
        type: String,
        default: ''
    },
    variant: {
        type: String,
        default: ''
    }
})
</script>
